<template>
	<div class="login">
		<div class="loginbox">
			<div class="title">账号登录</div>
			<el-input placeholder="请输入手机号码" v-model="phone">
				<template slot="prepend">+86</template>
			</el-input>
			<el-input placeholder="请输入密码" v-model="password" show-password></el-input>
			<div class="forget" @click="goForget">忘记密码？</div>
			<div class="register">
				没有账号？<span style="color: #51ba85" @click="goRegister">注册账号</span>
			</div>
			<el-button type="success" style="font-size:20px" @click="goLogin">登录</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				phone: '',
				password: ''
			}
		},
		methods: {
			goRegister() {
				this.$router.push('./register')
			},
			goForget() {
				this.$router.push('./forgetPsd')

			},
			goLogin() {
				if(!/^1[3-9]\d{9}$/.test(this.phone)){
					this.$message.error("请输入手机号")
					return
				}
				if(!this.password){
					this.$message.error("请输入密码")
					return
				}
				this.$http({
					url:'/api/Login/passwordLogin',
					data:{
						phone:this.phone,
						password:this.password
					}
				}).then(res => {
					if(res.code == 1){
						this.$message.success(res.msg)
						window.localStorage.token = res.data
						this.$router.push('./Index')
					}else{
						this.$message.error(res.msg)
					}
				})
				
			}
		}
	};
</script>

<style scoped>
	.el-button {
		width: 400px;
		height: 60px;
		margin-top: 44px;
		background-color: #51BA85;
	}

	.forget {
		font-size: 14px;
		color: #51BA85;
		text-align: right;
		margin-top: 14px;
	}

	.el-input__inner {
		font-size: 18px;
	}

	.el-input {
		margin-top: 51px;
		width: 400px;
		font-size: 18px;

	}

	.title {
		border-left: 6px solid #51ba85;
		padding-left: 8px;
		font-size: 36px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 600;
		color: #222222;
	}

	.login {
		position: relative;
		background: url(../assets/login/bg.png) no-repeat center center;
		background-size: 100% 100%;
		width: 100vw;
		height: 100vh;
	}

	.loginbox {
		width: 600px;
		height: 720px;
		padding: 80px 100px 0;
		box-sizing: border-box;
		position: absolute;
		right: 130px;
		top: 50%;
		transform: translateY(-50%);

		background: #ffffff;
		box-shadow: 0px 2px 20px 0px rgba(187, 210, 237, 0.2);
	}

	.register {
		font-size: 16px;
		color: #999999;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 600px;
		height: 80px;
		line-height: 80px;
		text-align: center;
		background: #f3f8ff;
	}
</style>
